<template lang="pug">
.odds-group
  template(v-if="mmoOdds")
    template(v-if="!!mmoDetails['hdp'] ")
      template(v-for="(det, ind) in mmoDetails['hdp']")
        template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
          oddsItemMMO(:odds="det" :idx="det[7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="ind" :details="mmoDetails" homeAway="1" pos=22)
        template(v-else)
          OddsDisabled
          
        template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
          oddsItemMMO(:odds="det" :idx="det[7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="ind" :details="mmoDetails" homeAway="2" pos=22)
        template(v-else)
          OddsDisabled
          
  template(v-else)
    template(v-if="!!details['hdp'] ")
      template(v-for="(det, ind) in details['hdp']")
        template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
          OddsItem(:odds="det" :idx="det[7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="ind" :details="details" homeAway="1")
        template(v-else)
          OddsDisabled
            
        template(v-if="det && det[9] != 0 && det[10] != 0 && det[9] != '' && det[10] != ''")
          OddsItem(:odds="det" :idx="det[7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="ind" :details="details" homeAway="2")
        template(v-else)
          OddsDisabled

</template>
<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import oddsItemMMO from "@/components/mobile/main/xitem/oddsItemMMO";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    oddsItemMMO
  },
  mixins: [mixinHDPOUOdds],
  methods: {
    toggleMoreMarkets() {
      this.$emit("toggle-more-markets");
    },
  }
};
</script>
